/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './chart-js-demo.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../shared/panel/panel.component.ngfactory';
import * as i3 from '../../../../../src/app/shared/panel/panel.component';
import * as i4 from '../../shared/chartjs-chart/chartjs-chart.component.ngfactory';
import * as i5 from '../../../../../src/app/shared/chartjs-chart/chartjs-chart.component';
import * as i6 from '../../shared/grid/grid.component.ngfactory';
import * as i7 from '../../../../../src/app/shared/grid/grid.component';
import * as i8 from '@angular/common';
import * as i9 from '../../../../../src/app/chart/chart-js/chart-js-demo.component';
const styles_ChartJSDemoComponent:any[] = [i0.styles];
export const RenderType_ChartJSDemoComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ChartJSDemoComponent,data:{}});
function View_ChartJSDemoComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'admin-panel',
      ([] as any[]),[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',
          (null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,1,'h3',[['class','header']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵeld(0,(null as any),1,1,
          'admin-chartjs-chart',([] as any[]),(null as any),(null as any),(null as any),
          i4.View_ChartJSChartComponent_0,i4.RenderType_ChartJSChartComponent)),i1.ɵdid(4898816,
          (null as any),0,i5.ChartJSChartComponent,([] as any[]),{width:[0,'width'],
              height:[1,'height'],type:[2,'type'],labels:[3,'labels'],datasets:[4,
                  'datasets']},(null as any))],(_ck,_v) => {
    const currVal_4:any = 1000;
    const currVal_5:any = 300;
    const currVal_6:any = (<any>_v.parent).context.$implicit.type;
    const currVal_7:any = (<any>_v.parent).context.$implicit.labels;
    const currVal_8:any = (<any>_v.parent).context.$implicit.datasets;
    _ck(_v,5,0,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).tabbed;
    const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
    const currVal_2:any = i1.ɵnov(_v,1).isClosed;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = (<any>_v.parent).context.$implicit.header;
    _ck(_v,3,0,currVal_3);
  });
}
function View_ChartJSDemoComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'admin-grid',([] as any[]),
      (null as any),(null as any),(null as any),i6.View_GridComponent_0,i6.RenderType_GridComponent)),
      i1.ɵdid(49152,(null as any),1,i7.GridComponent,([] as any[]),(null as any),(null as any)),
      i1.ɵqud(603979776,1,{templates:1}),(_l()(),i1.ɵand(0,[[1,2]],(null as any),0,
          (null as any),View_ChartJSDemoComponent_2))],(null as any),(null as any));
}
export function View_ChartJSDemoComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_ChartJSDemoComponent_1)),i1.ɵdid(802816,(null as any),0,i8.NgForOf,[i1.ViewContainerRef,
      i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any))],(_ck,
      _v) => {
    var _co:i9.ChartJSDemoComponent = _v.component;
    const currVal_0:any = _co.charts;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_ChartJSDemoComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_ChartJSDemoComponent_0,
      RenderType_ChartJSDemoComponent)),i1.ɵdid(49152,(null as any),0,i9.ChartJSDemoComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const ChartJSDemoComponentNgFactory:i1.ComponentFactory<i9.ChartJSDemoComponent> = i1.ɵccf('ng-component',
    i9.ChartJSDemoComponent,View_ChartJSDemoComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvY2hhcnQvY2hhcnQtanMvY2hhcnQtanMtZGVtby5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9jaGFydC9jaGFydC1qcy9jaGFydC1qcy1kZW1vLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvY2hhcnQvY2hhcnQtanMvY2hhcnQtanMtZGVtby5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvY2hhcnQvY2hhcnQtanMvY2hhcnQtanMtZGVtby5jb21wb25lbnQudHMuQ2hhcnRKU0RlbW9Db21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YWRtaW4tZ3JpZCAqbmdGb3I9XCJsZXQgY2hhcnQgb2YgY2hhcnRzXCI+PG5nLXRlbXBsYXRlPjxhZG1pbi1wYW5lbD48aDMgY2xhc3M9XCJoZWFkZXJcIj57e2NoYXJ0LmhlYWRlcn19PC9oMz48YWRtaW4tY2hhcnRqcy1jaGFydCBbdHlwZV09XCJjaGFydC50eXBlXCIgW2xhYmVsc109XCJjaGFydC5sYWJlbHNcIiBbZGF0YXNldHNdPVwiY2hhcnQuZGF0YXNldHNcIiBbd2lkdGhdPVwiMTAwMFwiIFtoZWlnaHRdPVwiMzAwXCI+PC9hZG1pbi1jaGFydGpzLWNoYXJ0PjwvYWRtaW4tcGFuZWw+PC9uZy10ZW1wbGF0ZT48L2FkbWluLWdyaWQ+IiwiPG5nLWNvbXBvbmVudD48L25nLWNvbXBvbmVudD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FzRDtNQUFBO1VBQUE7YUFBQTtVQUFBLGVBQWE7VUFBQTtNQUFtQix3Q0FBcUI7VUFBQTs2RUFBQSxVQUFBO1VBQUE7Y0FBQTtrQkFBQTtJQUE2RjtJQUFlO0lBQXZGO0lBQW9CO0lBQXdCO0lBQWpFLFdBQTZGLFVBQWUsVUFBdkYsVUFBb0IsVUFBd0IsU0FBakU7O0lBQXJEO0lBQUE7SUFBQTtJQUFBLFdBQUEsNkJBQUE7SUFBZ0M7SUFBQTs7OztvQkFBdEY7TUFBQTthQUFBO2FBQUEsNEJBQXlDO1VBQUE7OztvQkFBekM7TUFBQSxxQ0FBQTt1Q0FBQTs7O0lBQVk7SUFBWixXQUFZLFNBQVo7Ozs7b0JDQUE7TUFBQTtxQ0FBQSxVQUFBO01BQUE7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/chart/chart-js/chart-js-demo.component.ngfactory.ts